export {
  PAGE_TITLES,
  PATHS,
  PUBLIC_PATHS,
  TEMPLATES_PATH,
} from './routesRegistry';

export const BASE_ROUTE = '/:accountId/:projectId/';

export const SAMPLE_PROJECT_ACCOUNT_ID = 'SAMPLE_PROJECT_ACCOUNT';

/** regex to check if path is a project route: /:accountId/PROJECT-xxx/... or /templates/PROJECT-xxx/... */
export const PROJECT_ROUTE_PATTERN =
  /^(\/[^/]+\/PROJECT-[A-Z0-9]+(?:\/.*)?|\/templates\/PROJECT-[A-Z0-9]+(?:\/.*)?)/i;
